export default "__VITE_ASSET__D1U9VEi5__"